import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { io } from 'socket.io-client';
import axios from 'axios';
import NavHeader from '../shared/Nav-Header';
import styles from './messages.module.css';

const getSocketURL = () => {
  if (process.env.NODE_ENV === 'production') {
    return process.env.REACT_APP_API_URL || 'https://server-production-e45c.up.railway.app/';
  }
  return process.env.REACT_APP_API_URL || 'http://localhost:5000';
};

const socket = io(getSocketURL(), { 
  transports: ['websocket', 'polling'],
  withCredentials: true // Important for CORS with credentials
});


const GuestMessagesPage = ({ roomId }) => {
    const [messages, setMessages] = useState([]);
    const [recentMessage, setRecentMessage] = useState('');
    const [reloadMessage, setReloadMessage] = useState('');
    const [projectNetworkList, setProjectNetworkList] = useState([]);
    const [previousNetworkList, setPreviousNetworkList] = useState([]);
    const [userId1, setUserId1] = useState(null);
    const [userId, setUserId] = useState('');
    const [activeChat, setActiveChat] = useState(null);
    const [currentRoomId, setCurrentRoomId] = useState(null);
    const [showOptions, setShowOptions] = useState(null);
    const [showReadBy, setShowReadBy] = useState(null);
    const [chatBoxPosition, setChatBoxPosition] = useState({ right: 10, bottom: 20 });
    const navigate = useNavigate();
    const bottomRef = useRef(null);
    const chatBoxRef = useRef(null);
    const token = useMemo(() => localStorage.getItem('token'), []);

    useEffect(() => {
        const savedPosition = JSON.parse(localStorage.getItem('chatBoxPosition'));
        if (savedPosition) {
            setChatBoxPosition(savedPosition);
        }
    }, []);

    useEffect(() => {
        if (!roomId) return;

        socket.emit('joinRoom', { roomId });

        socket.on('receiveMessage', (newMessage) => {
            // console.log('New message received:fe', newMessage);
            setReloadMessage(newMessage);
            setMessages((prevMessages) => [...prevMessages, newMessage]);
        });

        return () => {
            socket.off('receiveMessage');
            if (currentRoomId) {
                socket.emit('leaveRoom', { roomId: currentRoomId });
            }
        };
    }, [currentRoomId, reloadMessage]);

    // useEffect(() => {
    //     // console.log('Updated currentRoomId:', currentRoomId);
    // }, [currentRoomId]);

    useEffect(() => {
        const fetchProjectNetworks = async () => {
            try {
                const response = await axios.get('/api/guest/applicant/messages/all-networks');

                setProjectNetworkList(response.data.projectNetworkList);
                setUserId1(response.data.userId);
                // setPreviousNetworkList(response.data.previousNetworkList);

                // Optional: filter out any duplicates between the two lists
                const filteredPrevious = response.data.previousNetworkList.filter(
                    prev => !response.data.projectNetworkList.some(
                    proj => proj._id === prev._id
                    )
                );
                setPreviousNetworkList(filteredPrevious);
                
                // console.log('Project Networks:', response.data);
            } catch (error) {
                // console.error('Error fetching project networks:', error);
            }
        };

        fetchProjectNetworks();
    }, []);

    useEffect(() => {
        if (currentRoomId) {
            fetchOlderMessages(currentRoomId);
        }
    }, [currentRoomId]);

    useEffect(() => {
        bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages]);

    const startChat = async (user1, user2) => {
        try {
            const response = await axios.post('/api/guest/applicant/messages/start-chat', { user1, user2 });

            if (response.data.success) {
                // console.log('response.data.roomId:', response.data.roomId);
                return response.data.roomId;
            }
        } catch (error) {
            // console.error('Error starting chat:', error);
        }
    };

    const fetchOlderMessages = async (currentRoomId) => {
        try {
            const response = await axios.post('/api/guest/applicant/messages/get-messages',
                { currentRoomId, userId }
            );

            if (response.data.success) {
                const filteredMessages = response.data.messages.filter(msg => !msg.deletedFor.includes(response.data.userId));
                setMessages(filteredMessages);
                setUserId(response.data.userId);
            }
        } catch (error) {
            // console.error('Error fetching old messages:', error);
        }
    };

    const handleChatClick = async (network) => {
        if (!userId1) return;

        if (currentRoomId) {
            socket.emit('leaveRoom', { roomId: currentRoomId });
        }

        try {
            const roomId = await startChat(userId1, network._id);
            if (roomId) {
                setActiveChat(network);
                // setCurrentRoomId(room._id);
                setCurrentRoomId(roomId);
                // socket.emit('joinRoom', { roomId: room._id });
                socket.emit('joinRoom', { roomId: roomId });
                // fetchOlderMessages(room._id);
                fetchOlderMessages(roomId);
            }
        } catch (error) {
            // console.error('Error handling chat click:', error);
        }
    };

    const handleCloseChat = () => {
        setActiveChat(null);
        localStorage.removeItem('chatBoxPosition');
    };

    const sendMessage = async () => {
        setRecentMessage('');

        if (!recentMessage.trim() || !currentRoomId || !userId1 || !activeChat?._id) {
            // console.error("Missing required fields:", { currentRoomId, userId1, activeChat, recentMessage });
            return;
        }

        try {
            const receiverId = activeChat._id;
            // console.log("currentRoomId:fe3", currentRoomId, "userId1:fe3", userId1, "activeChat :fe3", activeChat._id, "message:fe3", recentMessage);

            const requestData = {
                roomId: currentRoomId,
                senderId: userId1,
                receiverId,
                message: recentMessage
            };

            const response = await axios.post('/api/guest/applicant/messages/send-message', requestData, {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (response.data.success) {
                const newMessage = response.data.newMessage;
                socket.emit('sendMessage', newMessage);
                setMessages((prevMessages) => [...prevMessages, newMessage]);
                // console.log('Sent newMessage:fe3', newMessage);
            }
        } catch (error) {
            // console.error("Error sending message:", error.response?.data || error.message);
        }
    };

    const handleChatClick1 = (network) => {
        handleChatClick(network);
        setActiveChat(network);
    };

    const handleCloseChat1 = () => {
        handleCloseChat();
        setActiveChat(null);
    };

    const handleDeleteMessageForAll = async (messageId) => {
        try {
            await axios.post('/api/guest/applicant/messages/delete-message-for-all', { messageId }, {
                headers: { Authorization: `Bearer ${token}` }
            });

            setMessages((prevMessages) => prevMessages.filter(msg => msg._id !== messageId));
        } catch (error) {
            // console.error('Error deleting message for all:', error);
        }
    };

    const handleDeleteMessageForMe = async (messageId) => {
        try {
            await axios.post('/api/guest/applicant/messages/delete-message-for-me', { messageId }, {
                headers: { Authorization: `Bearer ${token}` }
            });

            setMessages((prevMessages) => prevMessages.filter(msg => msg._id !== messageId));
        } catch (error) {
            // console.error('Error deleting message for me:', error);
        }
    };

    const handleMarkRead = async (messageId) => {
        try {
            await axios.post('/api/guest/applicant/messages/mark-read', { messageId }, {
                headers: { Authorization: `Bearer ${token}` }
            });

            setMessages((prevMessages) => prevMessages.map(msg => {
                if (msg._id === messageId) {
                    return { ...msg, readBy: [...msg.readBy, { userId: userId1, readAt: new Date() }] };
                }
                return msg;
            }));
        } catch (error) {
            // console.error('Error marking message as read:', error);
        }
    };

    const formatDate = (date) => {
        const d = new Date(date);
        const now = new Date();
        const isThisYear = d.getFullYear() === now.getFullYear();
        const day = d.getDate().toString().padStart(2, '0');
        const month = (d.getMonth() + 1).toString().padStart(2, '0');
        const year = d.getFullYear().toString().slice(-2);
        const hours = d.getHours().toString().padStart(2, '0');
        const minutes = d.getMinutes().toString().padStart(2, '0');
        return isThisYear ? `${hours}:${minutes} ${day}/${month}` : `${hours}:${minutes} ${day}/${month}/${year}`;
    };

    const handleClickOutside = (event) => {
        if (!event.target.closest(`${styles.messageOptionsButton}`) && !event.target.closest(`${styles.messageOptionsMenu}`)) {
            setShowOptions(event);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const handleDragStart = (e) => {
        const chatBox = chatBoxRef.current;
        const rect = chatBox.getBoundingClientRect();
        const offsetX = e.clientX - rect.left;
        const offsetY = e.clientY - rect.top;

        const handleDrag = (e) => {
            const newLeft = e.clientX - offsetX;
            const newTop = e.clientY - offsetY;
            setChatBoxPosition({ top: newTop, left: newLeft });
        };

        const handleDragEnd = () => {
            document.removeEventListener('mousemove', handleDrag);
            document.removeEventListener('mouseup', handleDragEnd);
            localStorage.setItem('chatBoxPosition', JSON.stringify(chatBoxPosition));
        };

        document.addEventListener('mousemove', handleDrag);
        document.addEventListener('mouseup', handleDragEnd);
    };

    return (
        <>
            <NavHeader />
            <div className={styles.chatContainer}>
            <div className={styles.projectNetworksList}>
                <div className={styles.sectionHeader}>
                    <h3>Project Networks</h3>
                    <div className={styles.onlineIndicator}></div>
                </div>
                <ul>
                    {projectNetworkList.map((network) => (
                        <li key={network._id} onClick={() => handleChatClick1(network)} className={styles.networkItem}>
                            <div className={styles.profileContainer}>
                                <img src={network.profilePicture|| '/default-profile.png'} alt="Profile" className={styles.profilePicture} />
                                <div className={styles.statusDot}></div>
                            </div>
                            <div className={styles.networkInfo}>
                                <span className={styles.networkName}>{network.name}</span>
                                <span className={styles.lastSeen}>Active now</span>
                            </div>
                        </li>
                    ))}
                </ul>
                {previousNetworkList.length > 0 && (
                    <>
                        <div className={styles.sectionHeader}>
                            <h3>Previous Networks</h3>
                        </div>
                        <ul>
                            {previousNetworkList.map((network) => (
                                <li key={network._id} onClick={() => handleChatClick1(network)} className={styles.networkItem}>
                                    <div className={styles.profileContainer}>
                                        <img src={network.profilePicture || '/default-profile.png'} alt="Profile" className={styles.profilePicture} />
                                    </div>
                                    <div className={styles.networkInfo}>
                                        <span className={styles.networkName}>{network.name}</span>
                                        <span className={styles.lastSeen}>Last seen 2h ago</span>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </>
                )}
            </div>
            {activeChat && (
                <div
                    className={styles.chatPopup}
                    ref={chatBoxRef}
                    style={{ top: chatBoxPosition.top, left: chatBoxPosition.left }}
                    onMouseDown={handleDragStart}
                >
                    <div className={styles.chatPopupHeader}>
                        <div className={styles.chatHeaderInfo}>
                            <div className={styles.profileContainer}>
                                <img 
                                    src={activeChat.profilePicture ? activeChat.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : '/default-profile.png'}
                                    alt={activeChat.name} 
                                    className={styles.profilePictureHeader}
                                />
                                <div className={styles.statusDot}></div>
                            </div>
                            <div className={styles.chatInfo}>
                                <h3 className={styles.chatTitle}>{activeChat.name}</h3>
                                <span className={styles.activeStatus}>Active now</span>
                            </div>
                        </div>
                        <button onClick={handleCloseChat1} className={styles.closeButton}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                        </button>
                    </div>
                    <div className={styles.chatBox}>
                        <div className={styles.messagesContainer}>
                            {messages.map((msg, index) => (
                                <div key={index} className={`${styles.message} ${msg.senderId === userId1 ? styles.sent : styles.received}`}>
                                    <div className={styles.messageContent}>
                                        <div className={styles.messageText}>{msg.message}</div>
                                        <button 
                                            className={styles.messageOptionsButton} 
                                            onClick={() => {setShowOptions(showOptions === index ? null : index);}}
                                        >
                                            ⋮
                                        </button>
                                        {showOptions === index && (
                                            <div className={styles.messageOptionsMenu}>
                                                <button onClick={() => {handleMarkRead(msg._id);setShowOptions(null)}}>
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <path d="M9 12l2 2 4-4"/>
                                                        <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"/>
                                                    </svg>
                                                    Read by
                                                </button>
                                                <button onClick={() => {handleDeleteMessageForMe(msg._id);setShowOptions(null);}}>
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <polyline points="3,6 5,6 21,6"/>
                                                        <path d="M19,6V20a2,2,0,0,1-2,2H7a2,2,0,0,1-2-2V6"/>
                                                    </svg>
                                                    Delete for me
                                                </button>
                                                {msg.senderId === userId1 && (
                                                    <button onClick={() => {handleDeleteMessageForAll(msg._id);setShowOptions(null)}}>
                                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                            <polyline points="3,6 5,6 21,6"/>
                                                            <path d="M19,6V20a2,2,0,0,1-2,2H7a2,2,0,0,1-2-2V6"/>
                                                        </svg>
                                                        Delete for everyone
                                                    </button>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                    <div className={styles.messageTimestamp}>
                                        {formatDate(msg.createdAt)}
                                    </div>
                                    {showReadBy === index && msg.readBy && msg.readBy.length > 0 && (
                                        <div className={styles.messageReadRecipients}>
                                            Read by: {msg.readBy.map(recipient => (
                                                <span key={recipient.userId} className={styles.readByUser}>
                                                    <img src={recipient.profilePicture || '/default-profile.png'} alt={recipient.name} className={styles.recipientProfilePicture} />
                                                    {recipient.name}
                                                </span>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ))}
                            <div ref={bottomRef} />
                        </div>
                    </div>
                    <div className={styles.inputBox}>
                        <input
                            type="text"
                            value={recentMessage}
                            onChange={(e) => setRecentMessage(e.target.value)}
                            placeholder="Type a message..."
                            onKeyPress={(e) => e.key === 'Enter' && sendMessage()}
                        />
                        <button onClick={sendMessage} className={styles.sendButton}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <line x1="22" y1="2" x2="11" y2="13"></line>
                                <polygon points="22,2 15,22 11,13 2,9 22,2"></polygon>
                            </svg>
                        </button>
                    </div>
                </div>
            )}
        </div>

        </>
    );
};

export default GuestMessagesPage;

